/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Číselník typů chyb při registraci zařízení na serveru.
 * @enum {string}
 */
const SetupErrorType = {
  /** Chybí otisk zařízení. */
  AccessCodeMissing: 'AccessCodeMissing',
  /** Zařízení s daným ID je již registrováno. */
  DeviceExists: 'DeviceExists',
  /** Překročen počet povolených licencí. */
  DeviceLimitExceeded: 'DeviceLimitExceeded',
  /** Zařízení již bylo registrováno v jiné organizaci. */
  DeviceRegistered: 'DeviceRegistered',
  /** Nelze přidat zařízení do organizace. */
  OrganizationInvalid: 'OrganizationInvalid',
  /** Neexistující organizace. */
  OrganizationMissing: 'OrganizationMissing',
  /** Neplatný požadavek. */
  RequestInvalid: 'RequestInvalid',
  /** Chyba při ukládání. */
  SaveError: 'SaveError',
  /** Neplatné přihlašovací údaje. */
  UserInvalid: 'UserInvalid'
};

export default SetupErrorType;
